import { AppState, AppStateActionParams } from 'records/AppState';
import { getSheetSettings } from 'services/sheetSettingsService';

export interface SettingsActions {
  getSheetSettings: (actionParams: AppStateActionParams) => Promise<AppState>;
}

const settingsActions: SettingsActions = {
  getSheetSettings: async ({
    state,
  }: AppStateActionParams): Promise<AppState> => {
    const { selectedProject } = state();
    const response = await getSheetSettings(selectedProject);

    return state().setIn(['settings', 'sheets'], response);
  },
};

export default settingsActions;
